/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
// import { Card } from "react-bootstrap";

const cardShadow = `0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)`;
const cardShadowHover = `0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)`;
const transition = `all 0.3s cubic-bezier(.25,.8,.25,1)`;
const checkSize = `20px`;

export const SectionContainer = {
  backgroundColor: '#f2f5f8',
};

export const SectionNameStyle = {
  fontSize: '10px',
  color: '#a1aab9',
};

const Card = styled.div`
  transition: ${transition};
  border: 4px solid transparent;
  transition: ${transition};
  box-shadow: ${cardShadow};
  background: #fff;
  border-radius: ${(props) => props.borderRadius};
  &:hover {
    box-shadow: ${cardShadowHover};
  }
`;

export const AppCard = styled(Card)`
  cursor: pointer;
  height: 100%;
  position: relative;
  .check {
    transition: ${transition};
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: ${checkSize};
    height: ${checkSize};
    &:before {
      transition: ${transition};
      content: '';
      border: ${checkSize} solid;
      border-color: transparent;
      position: absolute;
      top: 0;
      right: 0;
      z-index: -1;
    }
    .checkmark {
      display: block;
      font: ${checkSize} sans-serif;
      line-height: ${checkSize};
      text-align: center;
      color: transparent;
    }
  }
  &.selected {
    border-color: ${(props) => props.selectedColor};
    .check {
      &:before {
        border-color: ${(props) => props.selectedColor}
          ${(props) => props.selectedColor} rgba(0, 0, 255, 0)
          rgba(255, 0, 0, 0);
      }
      .checkmark {
        color: ${(props) => props.checkMarkColor};
      }
    }
  }
`;

export const AppCardTitleImageStyle = {
  width: 80,
  height: 80,
};

export const DescriptionStyle = styled.p`
  fontsize: 0.9rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
`;

export const HeadingStyle = {
  fontSize: '1.0rem',
  overflow: 'hidden',
  display: '-webkit-box,',
  '-webkit-line-clamp': 2,
  textOverflow: 'ellipsis',
  lineClamp: 2,
  '-webkit-box-orient': 'vertical',
};

export const SelectableCard = styled(Card)`
  position: relative;
  transition: ${transition};
  border: 4px solid transparent;
  border-radius: ${(props) => props.borderRadius};
  .check {
    transition: ${transition};
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: ${checkSize};
    height: ${checkSize};
    &:before {
      transition: ${transition};
      content: '';
      border: ${checkSize} solid;
      border-color: transparent;
      position: absolute;
      top: 0;
      right: 0;
      z-index: -1;
    }
    .checkmark {
      display: block;
      font: ${checkSize} sans-serif;
      line-height: ${checkSize};
      text-align: center;
      color: transparent;
    }
  }
  &.selected {
    border-color: ${(props) => props.selectedColor};
    .check {
      &:before {
        border-color: ${(props) => props.selectedColor}
          ${(props) => props.selectedColor} rgba(0, 0, 255, 0)
          rgba(255, 0, 0, 0);
      }
      .checkmark {
        color: ${(props) => props.checkMarkColor};
      }
    }
  }
`;
